import cx from 'classnames'
import React from 'react'

import Arrow from './Arrow'

import styles from './styles.module.css'

export const TrendDirection = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  // unused (so far)
  SIDEWAYS: 'sideways',
  NONE: 'none',
}

const TrendIndicator = ({ direction, className, children, ...rest }) => (
  <span
    className={cx(styles.trendIndicator, styles[direction], className)}
    {...rest}
  >
    <Arrow />
    {!!children && <span>{children}</span>}
  </span>
)

export default TrendIndicator
